import React from 'react';
import './selected-campaigns.scss';
import { default as t } from '../../../utils/i18n';

const SelectedCampaignsContainer = ({ selectedCampaigns }) => {
  return (
    <div className="campaigns-list-container">
      <div className="list-scroll-container">
        <div className="selected-campaigns">
          {t('define.metric.selectedCampaign')}({selectedCampaigns?.campaigns?.length})
        </div>
        <div className="list-scroll">
          <div className="selected-list">
            {selectedCampaigns?.campaigns?.map(item => {
              return (
                <div className="selected-item" key={item.id}>
                  <span
                    className={
                      selectedCampaigns?.campaigns[0].campaignName === t('report.client.reporting.select.campaign')
                        ? 'selected-value selected-empty-value'
                        : 'selected-value'
                    }
                    title={item?.campaignName}
                  >
                    {item.campaignName?.length > 0 ? item?.campaignName : item?.campaignName}
                  </span>
                  {selectedCampaigns?.campaigns[0].campaignName === t('report.client.reporting.select.campaign') ? (
                    ''
                  ) : (
                    <span className="cross"></span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectedCampaignsContainer;
